import { useEffect, useState } from 'react';

function initializeWidget(): Promise<IHubSpotConversations | undefined> {
  return new Promise<IHubSpotConversations | undefined>((resolve, reject) => {
    const src = ENV.HUBSPOT_CONVERSATIONS;
    if (!ENV.HUBSPOT_CONVERSATIONS) { return resolve(undefined) }
    if (window.HubSpotConversations || window.hsConversationsOnReady) { return resolve(window.HubSpotConversations) }

    window.hsConversationsOnReady = [() => resolve(window.HubSpotConversations)];

    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    script.onerror = () => reject(new Error(`Script load error: ${src}`));
    document.body.appendChild(script);
  });
}

export function useHubSpotConversations(bottomOffset?: number)
  : (customer?: { email: string, token: string }) => void {

  useEffect(() => {
    let observer: MutationObserver | undefined;

    if (bottomOffset) {
      observer = new MutationObserver(() => {
        const item = document.getElementById('hubspot-messages-iframe-container');
        if (item) {
          item.style.setProperty('bottom', '60px', 'important');
          observer?.disconnect();
          observer = undefined;
        }
      });
      observer.observe(document.body, { childList: true, subtree: true, });
    }

    return () => {
      observer?.disconnect();
      window.HubSpotConversations?.widget.remove();
    }
  }, [bottomOffset]);

  return async (customer) => {
    window.hsConversationsSettings = {
      loadImmediately: false,
      identificationEmail: customer?.email,
      identificationToken: customer?.token,
    };
    
    await initializeWidget();
    window.HubSpotConversations?.widget.load();
  };
}